export const removeSwVCloak = {
  mounted () {
    const swVCloak = document.getElementById('sw-v-cloak');
    if (swVCloak) swVCloak.classList.add('hidden');
  },
};
